import "@/utils/expand"
import Vue from "vue"
import App from "./App.vue"
import plugin from "@/plugins"
// 先导入store再导入router，因为router依赖store
import store from "./store"
import router from "./router"
import VeLine from "v-charts/lib/line.common"
import VeRadar from "v-charts/lib/radar.common"
import VePie from "v-charts/lib/pie.common"
import VeGauge from "v-charts/lib/gauge.common"
import VeBar from "v-charts/lib/bar.common"
import Pagination from "@/components/Pagination";
import LoginDiolog from "@/components/loginDiolog";
import { install } from "vs-tree"
import ElementUI, { Message } from "element-ui"
import "vs-tree/dist/vs-tree.css"
import "default-passive-events"
import md5 from "js-md5";
// 加载 Vant 核心组件库
import VueCoreVideoPlayer from "vue-core-video-player"

// 加载 element 全局样式
// import "vant/lib/index.css"
import "./styles/theme/index.css"

// 加载全局样式
import "./styles/index.less"
// import "./styles/common.css"
// 加载动态设置 REM 基准值
// import "amfe-flexible"
import "@/utils/flexible"

// 加载 dayjs 初始化配置
import "./utils/dayjs"

import { handleSysBack, hook } from "./utils/nav";
import tool from "./utils/tool";
import Router from "vue-router";

const eventbus = new Vue();
// 注册使用 Vant 组件库
Vue.use(VueCoreVideoPlayer, {
    lang: "zh-CN"
})
Vue.use(ElementUI);
Vue.use(install);
Vue.use(tool);
Vue.use(Router);
Vue.prototype.$md5 = md5;
Vue.prototype.$bus = eventbus;
window.$bus = eventbus;
[VeLine, VeRadar, VePie, VeGauge, VeBar, Pagination, LoginDiolog].forEach(comp => {
    Vue.component(comp.name, comp)
})
Vue.filter("filterGroup", (text, orgName) => {
    if (String(orgName) === "朗润数据" || String(text) === "App注册" || String(text) === "app注册" || !text) return "无"
    return text || ""
})

Vue.config.productionTip = false
handleSysBack()
// hook()
Vue.use(plugin)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app")
